import type { GridCard } from '@Components/BigBrowse/Model/Classes/GridCard';
import type { PlaneTypes } from '@Components/BigBrowse/Model/ModelTypes';
import { observer } from 'mobx-react-lite';

import { ThreeUpImageGroup } from './Components/ThreeUpImageGroup';
import { ThreeUpSectionBox } from './Components/ThreeUpSectionBox';
import { ThreeUpTextPart } from './Components/ThreeUpTextPart';

type Props = {
  gridCard: GridCard<PlaneTypes.Layout_ThreeUp>;
};

export const ThreeUpLandScape = observer(function ThreeUpLandScape({
  gridCard,
}: Props) {
  return (
    <ThreeUpSectionBox gridCard={gridCard}>
      <ThreeUpTextPart gridCard={gridCard} />
      <ThreeUpImageGroup gridCard={gridCard} />
    </ThreeUpSectionBox>
  );
});
